import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Separator } from '@root/shared/ui-kit'

type Props = {
  followers: number | string
  following: number | string
  onFollowersClick: () => void
  onFollowingsClick: () => void
}

export const ProfileHeaderConnections = (props: Props) => {
  const { t } = useTranslation()
  return (
    <Connections>
      <Connection
        onClick={props.onFollowersClick}
        count={props.followers}
        description={
          typeof props.followers === 'number'
            ? t('common.follower', {
                count: props.followers,
              })
            : t('common.follower_other')
        }
      />
      <Sep vertical />
      <Connection
        onClick={props.onFollowingsClick}
        count={props.following}
        description={
          typeof props.following === 'number'
            ? t('common.following', {
                count: props.following,
              })
            : t('common.following_other')
        }
      />
    </Connections>
  )
}

const Connection = (props: {
  onClick: () => void
  count: number | string
  description: string
}) => (
  <ConnectionRoot onClick={props.onClick} type="button">
    <ConnectionCount>{props.count}</ConnectionCount>
    <ConnectionDescription>{props.description}</ConnectionDescription>
  </ConnectionRoot>
)

const Sep = styled(Separator)`
  margin: 8px 0;
  height: auto;
`

const Connections = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
`

const ConnectionRoot = styled.button`
  all: unset;
  cursor: pointer;
  text-align: center;
  padding: 10px;
`
const ConnectionCount = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: var(--text-11);

  transition: color 0.15s ease-in-out;

  ${ConnectionRoot}:hover & {
    color: var(--text-12);
  }
`
const ConnectionDescription = styled.div`
  color: var(--text-7);
  font-weight: 500;
  font-size: 12px;

  transition: color 0.15s ease-in-out;

  ${ConnectionRoot}:hover & {
    color: var(--text-9);
  }
`
